// modules are defined as an array
// [ module function, map of requires ]
//
// map of requires is short require name -> numeric require
//
// anything defined in a previous bundle is accessed via the
// orig method which is the require for previous bundles

(function (
  modules,
  entry,
  mainEntry,
  parcelRequireName,
  externals,
  distDir,
  publicUrl,
  devServer
) {
  /* eslint-disable no-undef */
  var globalObject =
    typeof globalThis !== 'undefined'
      ? globalThis
      : typeof self !== 'undefined'
      ? self
      : typeof window !== 'undefined'
      ? window
      : typeof global !== 'undefined'
      ? global
      : {};
  /* eslint-enable no-undef */

  // Save the require from previous bundle to this closure if any
  var previousRequire =
    typeof globalObject[parcelRequireName] === 'function' &&
    globalObject[parcelRequireName];

  var importMap = previousRequire.i || {};
  var cache = previousRequire.cache || {};
  // Do not use `require` to prevent Webpack from trying to bundle this call
  var nodeRequire =
    typeof module !== 'undefined' &&
    typeof module.require === 'function' &&
    module.require.bind(module);

  function newRequire(name, jumped) {
    if (!cache[name]) {
      if (!modules[name]) {
        if (externals[name]) {
          return externals[name];
        }
        // if we cannot find the module within our internal map or
        // cache jump to the current global require ie. the last bundle
        // that was added to the page.
        var currentRequire =
          typeof globalObject[parcelRequireName] === 'function' &&
          globalObject[parcelRequireName];
        if (!jumped && currentRequire) {
          return currentRequire(name, true);
        }

        // If there are other bundles on this page the require from the
        // previous one is saved to 'previousRequire'. Repeat this as
        // many times as there are bundles until the module is found or
        // we exhaust the require chain.
        if (previousRequire) {
          return previousRequire(name, true);
        }

        // Try the node require function if it exists.
        if (nodeRequire && typeof name === 'string') {
          return nodeRequire(name);
        }

        var err = new Error("Cannot find module '" + name + "'");
        err.code = 'MODULE_NOT_FOUND';
        throw err;
      }

      localRequire.resolve = resolve;
      localRequire.cache = {};

      var module = (cache[name] = new newRequire.Module(name));

      modules[name][0].call(
        module.exports,
        localRequire,
        module,
        module.exports,
        globalObject
      );
    }

    return cache[name].exports;

    function localRequire(x) {
      var res = localRequire.resolve(x);
      if (res === false) {
        return {};
      }
      // Synthesize a module to follow re-exports.
      if (Array.isArray(res)) {
        var m = {__esModule: true};
        res.forEach(function (v) {
          var key = v[0];
          var id = v[1];
          var exp = v[2] || v[0];
          var x = newRequire(id);
          if (key === '*') {
            Object.keys(x).forEach(function (key) {
              if (
                key === 'default' ||
                key === '__esModule' ||
                Object.prototype.hasOwnProperty.call(m, key)
              ) {
                return;
              }

              Object.defineProperty(m, key, {
                enumerable: true,
                get: function () {
                  return x[key];
                },
              });
            });
          } else if (exp === '*') {
            Object.defineProperty(m, key, {
              enumerable: true,
              value: x,
            });
          } else {
            Object.defineProperty(m, key, {
              enumerable: true,
              get: function () {
                if (exp === 'default') {
                  return x.__esModule ? x.default : x;
                }
                return x[exp];
              },
            });
          }
        });
        return m;
      }
      return newRequire(res);
    }

    function resolve(x) {
      var id = modules[name][1][x];
      return id != null ? id : x;
    }
  }

  function Module(moduleName) {
    this.id = moduleName;
    this.bundle = newRequire;
    this.require = nodeRequire;
    this.exports = {};
  }

  newRequire.isParcelRequire = true;
  newRequire.Module = Module;
  newRequire.modules = modules;
  newRequire.cache = cache;
  newRequire.parent = previousRequire;
  newRequire.distDir = distDir;
  newRequire.publicUrl = publicUrl;
  newRequire.devServer = devServer;
  newRequire.i = importMap;
  newRequire.register = function (id, exports) {
    modules[id] = [
      function (require, module) {
        module.exports = exports;
      },
      {},
    ];
  };

  // Only insert newRequire.load when it is actually used.
  // The code in this file is linted against ES5, so dynamic import is not allowed.
  // INSERT_LOAD_HERE

  Object.defineProperty(newRequire, 'root', {
    get: function () {
      return globalObject[parcelRequireName];
    },
  });

  globalObject[parcelRequireName] = newRequire;

  for (var i = 0; i < entry.length; i++) {
    newRequire(entry[i]);
  }

  if (mainEntry) {
    // Expose entry point to Node, AMD or browser globals
    // Based on https://github.com/ForbesLindesay/umd/blob/master/template.js
    var mainExports = newRequire(mainEntry);

    // CommonJS
    if (typeof exports === 'object' && typeof module !== 'undefined') {
      module.exports = mainExports;

      // RequireJS
    } else if (typeof define === 'function' && define.amd) {
      define(function () {
        return mainExports;
      });
    }
  }
})({"jqm97":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Home);
var _jsxRuntime = require("react/jsx-runtime");
var _s2LinHome160Svg = require("illustration:./S2_lin_home_160.svg");
var _s2LinHome160SvgDefault = parcelHelpers.interopDefault(_s2LinHome160Svg);
var _s2LinHome96Svg = require("illustration:./S2_lin_home_96.svg");
var _s2LinHome96SvgDefault = parcelHelpers.interopDefault(_s2LinHome96Svg);
var _s2LinHome48Svg = require("illustration:./S2_lin_home_48.svg");
var _s2LinHome48SvgDefault = parcelHelpers.interopDefault(_s2LinHome48Svg);
var _icon = require("../../src/Icon");
var _reactAriaComponents = require("react-aria-components");
function Home(props) {
    [props] = (0, _reactAriaComponents.useContextProps)(props, null, (0, _icon.IllustrationContext));
    let { size = 'M', ...otherProps } = props;
    switch(size){
        case 'L':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2LinHome160SvgDefault.default), {
                ...otherProps
            });
        case 'S':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2LinHome48SvgDefault.default), {
                ...otherProps
            });
        case 'M':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2LinHome96SvgDefault.default), {
                ...otherProps
            });
    }
}

},{"react/jsx-runtime":"2Is6Z","illustration:./S2_lin_home_160.svg":"1hN2h","illustration:./S2_lin_home_96.svg":"jy0sa","illustration:./S2_lin_home_48.svg":"bQmFf","../../src/Icon":"jQAJE","react-aria-components":"bA6Cz","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"1hN2h":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 160,
        height: 160,
        viewBox: "0 0 160 160",
        ref: ref,
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
            fillRule: "evenodd",
            d: "M92.494 20.998c-7.305-5.844-17.684-5.844-24.988 0L31.744 49.607c-4.744 3.795-7.506 9.542-7.506 15.617v50.502c0 11.045 8.955 20 20 20h71.523c11.046 0 20-8.955 20-20V65.224c0-6.075-2.762-11.822-7.506-15.617zm-19.99 6.247c4.382-3.506 10.61-3.506 14.992 0l35.761 28.609c2.847 2.277 4.504 5.725 4.504 9.37v50.502c0 6.627-5.373 12-12 12h-14.508V95.414c0-8.836-7.163-16-16-16H74.746c-8.837 0-16 7.164-16 16v32.312H44.238c-6.627 0-12-5.373-12-12V65.224c0-3.645 1.657-7.093 4.504-9.37zm-5.758 100.481h26.507V95.414c0-4.418-3.582-8-8-8H74.746c-4.419 0-8 3.582-8 8z"
        })
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIllustration)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"jy0sa":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 96,
        height: 96,
        viewBox: "0 0 96 96",
        ref: ref,
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
            fillRule: "evenodd",
            d: "M54.333 13.778c-3.684-3.014-8.982-3.014-12.665 0l-22 18c-2.322 1.9-3.668 4.74-3.668 7.74v30.481c0 5.523 4.477 10 10 10h44c5.523 0 10-4.477 10-10V39.518c0-3-1.346-5.84-3.668-7.74zM44.2 16.874c2.21-1.808 5.388-1.808 7.599 0l22 18c1.392 1.14 2.2 2.844 2.2 4.644v30.481c0 3.314-2.686 6-6 6H60V56c0-4.418-3.582-8-8-8h-8c-4.418 0-8 3.582-8 8v20H26c-3.314 0-6-2.686-6-6V39.518c0-1.8.808-3.505 2.2-4.644zM40 75.999h16V56c0-2.21-1.79-4-4-4h-8c-2.21 0-4 1.79-4 4z"
        })
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIllustration)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"bQmFf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 48,
        height: 48,
        viewBox: "0 0 48 48",
        ref: ref,
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
            fillRule: "evenodd",
            d: "M27.28 6.023c-1.918-1.533-4.642-1.533-6.56 0l-11 8.8c-1.245.997-1.97 2.505-1.97 4.1v15.578c0 2.899 2.35 5.25 5.25 5.25h22c2.9 0 5.25-2.351 5.25-5.25V18.923c0-1.595-.725-3.103-1.97-4.1zm-4.998 1.953c1.004-.804 2.432-.804 3.436 0l11 8.8c.652.521 1.032 1.312 1.032 2.147v15.578c0 1.518-1.231 2.75-2.75 2.75h-4.75V26.5c0-1.795-1.455-3.25-3.25-3.25h-6c-1.795 0-3.25 1.455-3.25 3.25v10.75H13c-1.519 0-2.75-1.232-2.75-2.75V18.923c0-.835.38-1.625 1.032-2.147zM20.25 37.25h7.5V26.5c0-.415-.336-.75-.75-.75h-6c-.414 0-.75.335-.75.75z"
        })
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIllustration)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"cpTLC":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>MailOpen);
var _jsxRuntime = require("react/jsx-runtime");
var _s2LinMailOpen160Svg = require("illustration:./S2_lin_mailOpen_160.svg");
var _s2LinMailOpen160SvgDefault = parcelHelpers.interopDefault(_s2LinMailOpen160Svg);
var _s2LinMailOpen96Svg = require("illustration:./S2_lin_mailOpen_96.svg");
var _s2LinMailOpen96SvgDefault = parcelHelpers.interopDefault(_s2LinMailOpen96Svg);
var _s2LinMailOpen48Svg = require("illustration:./S2_lin_mailOpen_48.svg");
var _s2LinMailOpen48SvgDefault = parcelHelpers.interopDefault(_s2LinMailOpen48Svg);
var _icon = require("../../src/Icon");
var _reactAriaComponents = require("react-aria-components");
function MailOpen(props) {
    [props] = (0, _reactAriaComponents.useContextProps)(props, null, (0, _icon.IllustrationContext));
    let { size = 'M', ...otherProps } = props;
    switch(size){
        case 'L':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2LinMailOpen160SvgDefault.default), {
                ...otherProps
            });
        case 'S':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2LinMailOpen48SvgDefault.default), {
                ...otherProps
            });
        case 'M':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2LinMailOpen96SvgDefault.default), {
                ...otherProps
            });
    }
}

},{"react/jsx-runtime":"2Is6Z","illustration:./S2_lin_mailOpen_160.svg":"l3U4A","illustration:./S2_lin_mailOpen_96.svg":"kCmEk","illustration:./S2_lin_mailOpen_48.svg":"WOwg2","../../src/Icon":"jQAJE","react-aria-components":"bA6Cz","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"l3U4A":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 160,
        height: 160,
        viewBox: "0 0 160 160",
        ref: ref,
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
            fillRule: "evenodd",
            d: "M82.292 28.677c-1.31-.819-2.967-.817-4.258-.008L35.531 55.268 48 63.154v-2.448C48 54.022 53.041 48 59.98 48h40.04c6.939 0 11.98 6.022 11.98 12.706v2.448l12.486-7.897-42.191-26.578zm45.688 33.836-17.842 11.284-.032.02L86.214 88.61l-.011.007c-3.907 2.443-8.862 2.42-12.748-.017h-.001l-23.58-14.794-.012-.008L32.02 62.513v53.477c0 6.631 5.369 12 12 12h71.96c6.629 0 12-5.378 12-12zM104 68.189v-7.483c0-2.936-2.101-4.706-3.98-4.706H59.98C58.101 56 56 57.77 56 60.706v7.498l21.704 13.617h.001c1.31.821 2.969.82 4.26.01l.019-.012zm-30.212-46.3c3.907-2.448 8.867-2.426 12.756.012l.008.005 47.56 29.96c1.162.732 1.868 2.01 1.868 3.384v60.74c0 11.038-8.95 20-20 20H44.02c-11.05 0-20-8.951-20-20V55.25c0-1.378.71-2.66 1.878-3.39L73.785 21.89l.002-.001"
        })
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIllustration)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"kCmEk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 96,
        height: 96,
        viewBox: "0 0 96 96",
        ref: ref,
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
            fillRule: "evenodd",
            d: "M44.912 14.492c1.947-1.213 4.418-1.213 6.365 0l.009.005 27.64 17.414c.632.336 1.064 1.002 1.064 1.769v36.27c0 5.524-4.476 10-10 10H26.02c-5.525 0-10-4.476-10-10V33.676c0-.487.175-.933.466-1.28q.117-.14.26-.259.114-.094.24-.17zm2.117 3.394-.002.001-25.246 15.798 8.03 5.06V35.85c0-3.315 2.685-6 6-6H60.2c3.314 0 6 2.685 6 6v2.841l8.018-5.017-25.057-15.787-.004-.002c-.651-.404-1.478-.404-2.13.001M62.2 41.194V35.85c0-1.105-.894-2-2-2H35.81c-1.105 0-2 .895-2 2v5.416l13.027 8.207.003.002c.652.405 1.48.404 2.132-.002zM51.088 52.867 75.99 37.284V69.95c0 3.315-2.685 6-6 6H26.02c-3.316 0-6-2.685-6-6V37.303l24.693 15.559.009.005c1.947 1.213 4.418 1.213 6.365 0"
        })
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIllustration)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"WOwg2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 48,
        height: 48,
        viewBox: "0 0 48 48",
        ref: ref,
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
            fillRule: "evenodd",
            d: "M25.643 7.213c-.975-.615-2.219-.615-3.194 0L7.98 16.818V34.99c0 2.762 2.238 5 5 5h22.04c2.763 0 5-2.238 5-5V16.82c0-.25-.09-.478-.241-.653q-.05-.06-.112-.11-.06-.051-.128-.093zm-1.066 1.692c-.324-.204-.739-.204-1.063 0l-.003.002-12.65 7.915 4.03 2.538V17.9c0-1.653 1.347-3 3-3h12.22c1.652 0 3 1.347 3 3v1.438l4.029-2.521zm6.534 11.684V17.9c0-.547-.453-1-1-1H17.89c-.548 0-1 .453-1 1v2.72l6.532 4.114c.324.205.74.205 1.064 0l.003-.001zM9.98 34.99V18.632l12.376 7.794c.975.616 2.22.616 3.195.001h.002l12.467-7.801V34.99c0 1.657-1.343 3-3 3H12.98c-1.658 0-3-1.343-3-3"
        })
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIllustration)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"6aQw0":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Paperairplane);
var _jsxRuntime = require("react/jsx-runtime");
var _s2LinPaperairplane160Svg = require("illustration:./S2_lin_paperairplane_160.svg");
var _s2LinPaperairplane160SvgDefault = parcelHelpers.interopDefault(_s2LinPaperairplane160Svg);
var _s2LinPaperairplane96Svg = require("illustration:./S2_lin_paperairplane_96.svg");
var _s2LinPaperairplane96SvgDefault = parcelHelpers.interopDefault(_s2LinPaperairplane96Svg);
var _s2LinPaperairplane48Svg = require("illustration:./S2_lin_paperairplane_48.svg");
var _s2LinPaperairplane48SvgDefault = parcelHelpers.interopDefault(_s2LinPaperairplane48Svg);
var _icon = require("../../src/Icon");
var _reactAriaComponents = require("react-aria-components");
function Paperairplane(props) {
    [props] = (0, _reactAriaComponents.useContextProps)(props, null, (0, _icon.IllustrationContext));
    let { size = 'M', ...otherProps } = props;
    switch(size){
        case 'L':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2LinPaperairplane160SvgDefault.default), {
                ...otherProps
            });
        case 'S':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2LinPaperairplane48SvgDefault.default), {
                ...otherProps
            });
        case 'M':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2LinPaperairplane96SvgDefault.default), {
                ...otherProps
            });
    }
}

},{"react/jsx-runtime":"2Is6Z","illustration:./S2_lin_paperairplane_160.svg":"d91SK","illustration:./S2_lin_paperairplane_96.svg":"4wBlu","illustration:./S2_lin_paperairplane_48.svg":"2MvWg","../../src/Icon":"jQAJE","react-aria-components":"bA6Cz","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"d91SK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 160,
        height: 160,
        viewBox: "0 0 160 160",
        ref: ref,
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
            fillRule: "evenodd",
            d: "M147.987 38.528c-2.531-2.703-6.395-4.19-10.589-3.246l-119.72 26.96c-9.44 2.126-11.871 14.454-3.847 19.943L38 98.72v32.097c0 7.625 8.973 11.238 14.52 6.622l18.985-15.798 21.065 14.41c5.543 3.792 13.194 1.865 16.238-4.139l40.98-80.825c1.684-3.32 1.531-6.797.171-9.666-.063-.43-.198-.856-.409-1.263-.368-.708-.918-1.26-1.563-1.629m-15.768 6.12L19.436 70.046c-2.678.603-3.298 4.024-1.088 5.536L41.776 91.61zm-81.83 52.854 46.698 31.946c1.579 1.08 3.74.512 4.586-1.155l40.445-79.77-92.835 48.202zM46 104.195v26.621c0 .163.042.255.091.324.06.088.174.193.346.27.35.156.69.11.967-.121l17.02-14.163z"
        })
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIllustration)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"4wBlu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 96,
        height: 96,
        viewBox: "0 0 96 96",
        ref: ref,
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
            fillRule: "evenodd",
            d: "M91.725 24.406c2.709-5.4-2.058-11.568-7.975-10.221L8.074 31.41C1.99 32.795.473 40.771 5.597 44.314l1.137-1.645-1.137 1.645L19.5 53.93v23.43c0 4.13 4.887 5.96 7.84 3.55L41.64 69.238l13.729 9.493c3.577 2.474 8.503 1.203 10.452-2.682zM38.215 66.87 23.501 56.695V77.36c0 .218.114.43.415.562.305.133.638.099.896-.112zM25.52 53.227l32.125 22.214c1.57 1.086 3.739.534 4.601-1.186L88.15 22.613q.209-.421.29-.847zm61.023-34.984c-.567-.239-1.22-.314-1.904-.158L8.962 35.31c-2.676.61-3.365 4.141-1.09 5.714l13.893 9.608z"
        })
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIllustration)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"2MvWg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 48,
        height: 48,
        viewBox: "0 0 48 48",
        ref: ref,
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
            fillRule: "evenodd",
            d: "M46.014 12.421c1.33-2.642-1.014-5.641-3.9-4.987L4.335 15.999c-2.974.674-3.723 4.566-1.21 6.296l.589-.857-.59.857 7.353 5.064v10.544c0 2.35 2.758 3.618 4.541 2.087l6.143-5.273 6.81 4.69c1.748 1.204 4.156.588 5.111-1.308zm-26.982 20.83-6.055-4.17v8.822c0 .214.25.329.413.19zm-4.714-6.282 15.071 10.38c.5.343 1.188.167 1.46-.374l12.559-24.938zM41.745 10.08 4.888 18.437c-.85.192-1.064 1.304-.346 1.799l7.438 5.122z"
        })
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIllustration)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"k9wo9":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Phone);
var _jsxRuntime = require("react/jsx-runtime");
var _s2LinPhone160Svg = require("illustration:./S2_lin_phone_160.svg");
var _s2LinPhone160SvgDefault = parcelHelpers.interopDefault(_s2LinPhone160Svg);
var _s2LinPhone96Svg = require("illustration:./S2_lin_phone_96.svg");
var _s2LinPhone96SvgDefault = parcelHelpers.interopDefault(_s2LinPhone96Svg);
var _s2LinPhone48Svg = require("illustration:./S2_lin_phone_48.svg");
var _s2LinPhone48SvgDefault = parcelHelpers.interopDefault(_s2LinPhone48Svg);
var _icon = require("../../src/Icon");
var _reactAriaComponents = require("react-aria-components");
function Phone(props) {
    [props] = (0, _reactAriaComponents.useContextProps)(props, null, (0, _icon.IllustrationContext));
    let { size = 'M', ...otherProps } = props;
    switch(size){
        case 'L':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2LinPhone160SvgDefault.default), {
                ...otherProps
            });
        case 'S':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2LinPhone48SvgDefault.default), {
                ...otherProps
            });
        case 'M':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2LinPhone96SvgDefault.default), {
                ...otherProps
            });
    }
}

},{"react/jsx-runtime":"2Is6Z","illustration:./S2_lin_phone_160.svg":"cICwk","illustration:./S2_lin_phone_96.svg":"i5foW","illustration:./S2_lin_phone_48.svg":"j3Ovi","../../src/Icon":"jQAJE","react-aria-components":"bA6Cz","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"cICwk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 160,
        height: 160,
        viewBox: "0 0 160 160",
        ref: ref,
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
            fillRule: "evenodd",
            d: "M55 40c0-4.418 3.582-8 8-8h34c4.418 0 8 3.582 8 8v80c0 4.418-3.582 8-8 8H63c-4.418 0-8-3.582-8-8zm8-16c-8.837 0-16 7.163-16 16v80c0 8.837 7.163 16 16 16h34c8.837 0 16-7.163 16-16V40c0-8.837-7.163-16-16-16zm22 92.5c0 2.485-2.015 4.5-4.5 4.5s-4.5-2.015-4.5-4.5 2.015-4.5 4.5-4.5 4.5 2.015 4.5 4.5"
        })
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIllustration)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"i5foW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 96,
        height: 96,
        viewBox: "0 0 96 96",
        ref: ref,
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
            fillRule: "evenodd",
            d: "M33.5 24c0-2.21 1.79-4 4-4h22c2.21 0 4 1.79 4 4v48c0 2.21-1.79 4-4 4h-22c-2.21 0-4-1.79-4-4zm4-8c-4.418 0-8 3.582-8 8v48c0 4.418 3.582 8 8 8h22c4.418 0 8-3.582 8-8V24c0-4.418-3.582-8-8-8zM51 70.5c0 1.38-1.12 2.5-2.5 2.5S46 71.88 46 70.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5"
        })
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIllustration)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"j3Ovi":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 48,
        height: 48,
        viewBox: "0 0 48 48",
        ref: ref,
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
            fillRule: "evenodd",
            d: "M16.25 13c0-1.519 1.231-2.75 2.75-2.75h10c1.519 0 2.75 1.231 2.75 2.75v22c0 1.519-1.231 2.75-2.75 2.75H19c-1.519 0-2.75-1.231-2.75-2.75zM19 7.75c-2.9 0-5.25 2.35-5.25 5.25v22c0 2.9 2.35 5.25 5.25 5.25h10c2.9 0 5.25-2.35 5.25-5.25V13c0-2.9-2.35-5.25-5.25-5.25zm6.5 26.75c0 .828-.672 1.5-1.5 1.5s-1.5-.672-1.5-1.5.672-1.5 1.5-1.5 1.5.672 1.5 1.5"
        })
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIllustration)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}]},[], null, "parcelRequire7f0c", {})

//# sourceMappingURL=SelectBoxGroup.f89aebf0.js.map
